var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupportIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 72,
    viewBox: "0 0 73 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 36,
    r: 36,
    fill: "#0098FF",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.2502 19.2852V20.3924C44.2502 23.4503 46.7279 25.928 49.7858 25.928C52.8437 25.928 55.3215 23.4503 55.3215 20.3924V15.3062C55.3215 12.6125 53.1371 10.4282 50.4435 10.4282H49.7858C46.4644 10.4282 43.143 8.21388 43.143 8.21388C43.143 8.21388 42.0359 9.32102 42.0359 11.5353C42.0359 14.8567 44.2502 17.071 47.5716 17.071",
    stroke: "#0098FF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2498 20.3929V16.1226",
    stroke: "#0098FF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4641 29.2498C46.4641 29.2498 47.5712 30.3569 49.7855 30.3569C51.9998 30.3569 53.1069 29.2498 53.1069 29.2498",
    stroke: "#0098FF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4287 31.464V27.3942",
    stroke: "#0098FF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2143 40.3209C23.2143 40.3209 22.1072 41.428 19.8929 41.428C17.6787 41.428 16.5715 40.3209 16.5715 40.3209",
    stroke: "#0098FF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4997 44.7497H30.4949",
    stroke: "#0098FF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4285 30.3569V31.4641C25.4285 34.522 22.9508 36.9997 19.8929 36.9997C16.8349 36.9997 14.3572 34.522 14.3572 31.4641V26.3779C14.3572 23.6842 16.5416 21.4998 19.2352 21.4998H19.8929H25.4285C26.6508 21.4998 27.6428 22.4918 27.6428 23.7141C27.6428 26.4133 25.4285 28.1427 22.1071 28.1427",
    stroke: "#0098FF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7498 50.2857V67.9999",
    stroke: "#0098FF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7028 52.5663L38.7793 49.6845C39.2299 49.3656 39.7801 49.1785 40.3747 49.1785C41.9036 49.1785 43.1425 50.4174 43.1425 51.9463C43.1425 52.7401 42.807 53.4554 42.2734 53.9602L36.565 59.3442C35.9694 59.9055 35.1678 60.2498 34.2854 60.2498C33.5005 60.2498 32.7808 59.9697 32.2084 59.5191L28.7498 56.79",
    stroke: "#0098FF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M35.756 54.5234L30.1229 44.0577C29.5948 43.0767 28.7246 42.325 27.6772 41.9441L23.2144 40.3211V35.8925",
    stroke: "#0098FF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M24.546 67.8094L17.5058 48.2165C16.2802 44.8087 13.0484 42.5358 9.42922 42.5358H5.5",
    stroke: "#0098FF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2607 42.7346L12.2217 42.0183C12.8849 41.5245 13.6322 41.1547 14.4283 40.93L16.5717 40.3211V35.8925",
    stroke: "#0098FF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1267 56.9284H67.5004",
    stroke: "#0098FF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7494 44.7494L60.7925 34.2327C60.1327 32.4812 58.7189 31.1195 56.943 30.5282L53.1068 29.2495V24.821",
    stroke: "#0098FF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9654 44.7494L43.8732 34.8981C43.4392 33.5131 42.1538 32.5709 40.7035 32.5709H28.7498",
    stroke: "#0098FF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4644 24.821V29.2495L44.3 29.8684C43.6401 30.0566 43.0223 30.3655 42.4743 30.7785L40.0984 32.5709",
    stroke: "#0098FF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5752 40.3209H54.2142C56.0476 40.3209 57.5356 41.8077 57.5356 43.6423C57.5356 44.2545 57.0407 44.7494 56.4284 44.7494",
    stroke: "#0098FF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7912 20.3008L32.0759 17.0713H19.893C18.6707 17.0713 17.6787 16.0793 17.6787 14.857V8.21424C17.6787 6.99196 18.6707 5.99997 19.893 5.99997H35.3929C36.6151 5.99997 37.6071 6.99196 37.6071 8.21424V19.8702C37.6071 20.2898 37.1366 20.5378 36.7912 20.3008Z",
    stroke: "#0098FF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0715 11.6788C31.9926 11.6788 31.9286 11.6148 31.9286 11.5359C31.9286 11.457 31.9926 11.3931 32.0715 11.3931C32.1504 11.3931 32.2144 11.457 32.2144 11.5359C32.2144 11.6148 32.1504 11.6788 32.0715 11.6788Z",
    fill: "#0098FF",
    stroke: "#0098FF",
    strokeWidth: 2.5
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M27.643 11.6788C27.5641 11.6788 27.5002 11.6148 27.5002 11.5359C27.5002 11.457 27.5641 11.3931 27.643 11.3931C27.7219 11.3931 27.7859 11.457 27.7859 11.5359C27.7859 11.6148 27.7219 11.6788 27.643 11.6788Z",
    fill: "#0098FF",
    stroke: "#0098FF",
    strokeWidth: 2.5
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2143 11.6788C23.1354 11.6788 23.0714 11.6148 23.0714 11.5359C23.0714 11.457 23.1354 11.3931 23.2143 11.3931C23.2932 11.3931 23.3572 11.457 23.3572 11.5359C23.3572 11.6148 23.2932 11.6788 23.2143 11.6788Z",
    fill: "#0098FF",
    stroke: "#0098FF",
    strokeWidth: 2.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportIcon);
export default __webpack_public_path__ + "static/media/support-icon.aaeb31650d8bb7eee5114b032820bbf3.svg";
export { ForwardRef as ReactComponent };